import React from 'react';
import Category from '../models/Category';
import Section from '../models/Section';
import SubnavDropdown from './SubnavDropdown';
import MobileSubnavDropdown from './MobileSubnavDropdown';
import CategoryLink from './CategoryLink';
import ReadingProgress from 'react-reading-progress';
import { blogEndpoint } from '../Blog';
import DelayedUntilLoad from '../components/DelayedUntilLoad';
import getPreviewMode, { turnPreviewModeOff } from '@gik/core/utils/PreviewMode';
import Link from '@/components/Link';
import { Button } from '@gik/ui';

interface SubnavProps {
  categories: Category[];
  situations: Section[];
  tags: Section[];
  showReadingProgress: boolean;
  asPageHeading: boolean;
}

export default class Subnav extends React.PureComponent<SubnavProps> {
  render() {
    const NavTitleElement = this.props.asPageHeading ? 'h1' : 'span';
    return (
      <header className="subnav">
        <nav className="header bs-padding">
          <div className="title">
            <Link href={`/${blogEndpoint}`}>
              <a>
                <NavTitleElement className="title">Learn InKind</NavTitleElement>
              </a>
            </Link>
            {getPreviewMode() && (
              <span className="preview-mode-toggle">
                PREVIEW MODE{' '}
                <Button onClick={() => turnPreviewModeOff()} size="xs" variant="danger" type="button">
                  TURN OFF
                </Button>
              </span>
            )}
          </div>
          <div className="content">
            <div className="mobile-only">
              <MobileSubnavDropdown {...this.props} />
            </div>
            <div className="not-mobile horizontal">
              <SubnavDropdown heading="Situations" sections={this.props.situations} sectionsClickable={true} />
              {this.props.categories.map(category => (
                <CategoryLink key={category.name} category={category} />
              ))}
              <SubnavDropdown className="tags" heading="Tags" sections={this.props.tags} searchable />
            </div>
          </div>
        </nav>
        {this.props.showReadingProgress && (
          <DelayedUntilLoad>
            <ReadingProgress targetEl="#article-body" />
          </DelayedUntilLoad>
        )}
      </header>
    );
  }
}
